/**
 * Typebox types used for runtime checks.  These cannot be declared in .d.ts files.
 */

import {Type, type Static} from "@sinclair/typebox";

export const CsProjectTypebox = Type.Object({
	name: Type.String(),
	"ide-mode": Type.String(),
	multiplayerClass: Type.Optional(Type.String()),
	files: Type.Array(
		Type.Object({
			name: Type.String(),
			attributes: Type.Optional(
				Type.Object({
					hidden: Type.Optional(Type.Boolean()),
					isMarkdown: Type.Optional(Type.Boolean()),
					isReadOnly: Type.Optional(Type.Boolean()),
					open: Type.Optional(Type.Boolean()),
				})
			),
			content: Type.String(),
		})
	),
});

export type CsProjectT = Static<typeof CsProjectTypebox>;
